import Conversation from './conversationType';

const emptyConversation: Conversation = {
  UUID: '',
  UserUUID: '',
  Name: '',
  StartDate: '',
  LastUpdated: '',
  RepositoryUUID: '',
  TicketUUID: '',
  IsActive: false,
  VectorDBUrl: '',
};

export default emptyConversation;
